import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '../store'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      requiresAuth: true, // Indicates that this route requires authentication
    }
  },
  {
    path: '/institucional',
    name: 'institucional',
    meta: { module: 'institucional' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/InstitucionalView.vue')
  },
  {
    path: '/contacto',
    name: 'contacto',
    meta: { module: 'contacto' },
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactoView.vue')
  },
  {
    path: '/novedades',
    name: 'novedades',
    meta: { module: 'novedades', name: 'Novedades' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NovedadesView.vue')
  },
  {
    path: '/novedades/:id?',
    name: 'novedad',
    meta: { module: 'novedades', name: 'Novedades' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NovedadesView.vue')
  },
  {
    path: '/eventos',
    name: 'eventos',
    meta: { module: 'eventos', name: 'Eventos' },
    component: () => import(/* webpackChunkName: "about" */ '../views/EventosView.vue')
  },
  {
    path: '/eventos/:id?',
    name: 'evento',
    meta: { module: 'eventos', name: 'Eventos' },
    component: () => import(/* webpackChunkName: "about" */ '../views/EventosView.vue')
  },
  {
    path: '/proyecto',
    name: 'proyecto',
    meta: { module: 'proyecto' },
    component: () => import(/* webpackChunkName: "about" */ '../views/ProyectoEducativoView.vue')
  },
  {
    path: '/inscripciones',
    name: 'inscripciones',
    meta: { module: 'inscripciones' },
    component: () => import(/* webpackChunkName: "about" */ '../views/AdmisionesView.vue')
  },
  {
    path: '/administracion',
    name: 'administracion',
    meta: { module: 'administracion' },
    component: () => import(/* webpackChunkName: "about" */ '../views/AdministracionView.vue')
  },
  {
    path: '/inscripciones',
    name: 'inscripciones',
    meta: { module: 'inscripciones', name: "Inscripciones" },
    component: () => import(/* webpackChunkName: "about" */ '../views/AdmisionesView.vue')
  },
  {
    path: '/autogestion',
    name: 'autogestion',
    meta: { module: 'autogestion' },
    component: () => import(/* webpackChunkName: "about" */ '../views/AutogestionView.vue')
  },
  {
    path: '/cv',
    name: 'cv',
    meta: { module: 'cv' },
    component: () => import(/* webpackChunkName: "about" */ '../views/EnviaCurriculumView.vue')
  },
  {
    path: '/instalaciones',
    name: 'instalaciones',
    meta: { module: 'instalaciones' },
    component: () => import(/* webpackChunkName: "about" */ '../views/InstalacionesView.vue')
  },
  {
    path: '/documentacion',
    name: 'documentacion',
    meta: { module: 'documentacion' },
    component: () => import(/* webpackChunkName: "about" */ '../views/DocumentacionView.vue')
  },
  {
    path: '/nivel_inicial',
    name: 'nivel_inicial',
    meta: { module: 'nivel_inicial' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NivelInicialView.vue')
  },
  {
    path: '/nivel_primario',
    name: 'nivel_primario',
    meta: { module: 'nivel_primario' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NivelPrimarioView.vue')
  },
  {
    path: '/nivel_secundario',
    name: 'nivel_secundario',
    meta: { module: 'nivel_secundario' },
    component: () => import(/* webpackChunkName: "about" */ '../views/NivelSecundarioView.vue')
  },
  {
    path: '/autoridades',
    name: 'autoridades',
    meta: { module: 'autoridades' },
    component: () => import(/* webpackChunkName: "about" */ '../views/AutoridadesView.vue')
  },
  {
    path: '/pastoral',
    name: 'pastoral',
    meta: { module: 'pastoral' },
    component: () => import(/* webpackChunkName: "about" */ '../views/PastoralView.vue')
  },
  {
    path: '/parroquia',
    name: 'parroquia',
    meta: { module: 'parroquia' },
    component: () => import(/* webpackChunkName: "about" */ '../views/ParroquiaView.vue')
  },
  {
    path: '/colegiosdiocesanos',
    name: 'colegiosdiocesanos',
    meta: { module: 'colegiosdiocesanos' },
    component: () => import(/* webpackChunkName: "about" */ '../views/ColegiosDiocesanosView.vue')
  },
  {
    path: '/ecoferia',
    name: 'ecoferia',
    meta: { module: 'ecoferia' },
    component: () => import(/* webpackChunkName: "about" */ '../views/EcoferiaView.vue')
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // Store route metadata in Vuex store
  store.dispatch('setRouteMeta', to.meta)
  next()
})

export default router
